import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { StaffService } from "../services/staff.service";
import { Subscription } from "rxjs";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { DialogService } from "primeng/dynamicdialog";
import { AddStaffComponent } from "../add-staff/add-staff.component";
import { EditStaffComponent } from "../edit-staff/edit-staff.component";
import { UserService } from "../../../shared";
import { ConfirmationService } from "primeng/api";
import * as moment from "moment";

@Component({
	templateUrl: "./viewstaff.component.html",
	styleUrls: ["./viewstaff.component.css"],
})
export class ViewStaffComponent implements OnInit, OnDestroy {
	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscription.unsubscribe();
	}

	constructor(
		private studentService: PersonSelectorService,
		private staffService: StaffService,
		private dialogService: DialogService,
		private personSelectorService: PersonSelectorService,
		private userService: UserService,
		private confirmationService: ConfirmationService
	) {}
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.studentService.onPersonSelectChange().subscribe((person) => {
			this.selectedStudent = person;
			this.StaffGets();
		});
	}

	///////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////

	user: any;

	subscription: Subscription;
	ViewStaff: any;

	processing: any = false;
	selectedStudent: any;

	AdminSignature: any = "";

	PersonLoading: any = false;

	SchoolShowLastIDCard: boolean = false;
	IDCardSide1Enabled: boolean = false;
	IDCardSide2Enabled: boolean = false;
	IDCardSide1: string = "";
	IDCardSide2: string = "";

	SSNLabel: string = "Staff SN";

	lstExtendedInfo: any = [];
	lstExtendedInfoLCol: any = [];
	lstExtendedInfoRCol: any = [];

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////

	private StaffGets() {
		this.PersonLoading = true;

		var result = this.staffService.StaffGets(this.selectedStudent.PersonID);
		result.subscribe(
			(response: any) => {
				this.ViewStaff = response;

				this.ViewStaff.DOB = moment(new Date(this.ViewStaff.DOB)).format("MM/DD/YYYY");

				if (
					String(this.ViewStaff.DOB).toLowerCase().indexOf("invalid") != -1 ||
					String(this.ViewStaff.DOB) == "01/01/0001" ||
					String(this.ViewStaff.DOB) == "01/01/1900"
				) {
					this.ViewStaff.DOB = "";
				}

				this.SSNLabel = this.ViewStaff.StaffSSNLabel;

				this.lstExtendedInfo = [];
				this.lstExtendedInfoLCol = [];
				this.lstExtendedInfoRCol = [];

				if (this.ViewStaff.lstExtendedInfo != null) {
					this.lstExtendedInfo = this.ViewStaff.lstExtendedInfo;

					for (var z = 0; z < this.lstExtendedInfo.length; z++) {
						var next = this.lstExtendedInfo[z];

						if (z % 2 == 0) {
							this.lstExtendedInfoLCol = [...this.lstExtendedInfoLCol, next];
						} else {
							this.lstExtendedInfoRCol = [...this.lstExtendedInfoRCol, next];
						}
					}
				}

				this.PersonLoading = false;
			},
			(error) => {
				this.PersonLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////

	// print(){

	//   this.processing=true;
	//   var result = this.demographicsService.print(this.selectedStudent.PersonID,this.selectedStudent.SchoolID);
	//   result.subscribe(
	//     (response:any) => {
	//       this.processing=false;
	//       window.open(response);
	//     },
	//     error => {
	//       this.processing=false;
	//     }
	//   )
	// }

	onAddStaff() {
		var ref = this.dialogService.open(AddStaffComponent, {
			header: "Add Staff",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.personSelectorService.TableRefresh("Refresh");
				// this.studentService.onPersonSelectChange();

				this.StaffGets();
			}
		});
	}

	onEditStaff() {
		if (this.selectedStudent == undefined) {
			return;
		}

		var ref = this.dialogService.open(EditStaffComponent, {
			header: "Edit Staff",
			width: "fit-content",
			data: {
				PersonID: this.selectedStudent.PersonID,
				// ViewStaff: this.ViewStaff
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.personSelectorService.TableRefresh("Refresh");
				//this.studentService.onPersonSelectChange();

				this.StaffGets();
			}
		});
	}

	// EditDisabled(){
	//   //Check permission

	//   if(this.selectedStudent != undefined){
	//     //Only SU can edit System and imported excuses
	//     if(this.user.userID != 0 && this.selectedStudent.DefinedByID <= 2){
	//       // this.errorMessage = "You do not have permission to edit this excuse";
	//       return true;
	//     }
	//     //District users can edit any other excuses
	//     //School Users can only edit school level excuses
	//     if(this.user.UserLevelID == 3 && this.selectedStudent.PersonTypeID == 3){
	//       // this.errorMessage = "You do not have permission to edit this excuse";
	//       return true;
	//     }

	//     return false;
	//   }
	//   else{
	//     return true;
	//   }
	// }

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	///////////////////////////////////////////////////////////////////////
}
